import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { GRUPO_UNIDADE_NEGOCIO_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    GRUPO_UNIDADE_NEGOCIO_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    GRUPO_UNIDADE_NEGOCIO_ENDPOINT,
    id
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [GRUPO_UNIDADE_NEGOCIO_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [GRUPO_UNIDADE_NEGOCIO_ENDPOINT],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [GRUPO_UNIDADE_NEGOCIO_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [GRUPO_UNIDADE_NEGOCIO_ENDPOINT],
    id
  );
}
